export default __webpack_public_path__ + "static/launch-partner_SilverPoet_left@2x-c08b106a2b1f0335b10684451b49ba41.jpg";